import React, {useState, useNavia, useEffect} from 'react'
import {ReactComponent as ChevronRight} from '../../../assets/icons/chevron-right.svg'
import {usePreviewArtworks} from '../../../hooks/usePreviewArtworks'
import {useSelectedVariantContext} from '../context/SelectedVariantContext'
import Bluebird from 'bluebird'
import {saveTempImagesDesign, saveTempMockupDesign} from '../../../services/ProductLinesServices'
import {getLinksUploadArtwork, uploadTempArtwork} from '../../../services/ArtworkTemplateServices'
import {getCurrentStore} from '../../../services/CurrentStoreServices'
import {getDefaultBaseURL} from '../../../services/CreateStoreAPIService'
import {isBackofficeEnv} from '../../../helpers/isBackoffceEnv'
import {getLocalData, setLocalData} from '../../../services/StorageServices'
import {base64ToFile} from '../../../helpers/imageFormat'
import useUploadBackgroundPublish from '../../../hooks/useUploadBackgroundPublish'
import {createProductCombine, uploadArtworkCapture} from '../../../helpers/createProductCombine'
import {handleMergeDesignCaptures, saveBlobToFile} from '../context/SelectedVariantContext/helper'
import {Button, Spinner} from 'reactstrap'
import {createMappingAndSaveArtwork, mergeAttributesByDesignEdited} from '../context/SelectedVariantContext/helper'
import {useNavigate} from 'react-router-dom'
import {isArray} from 'lodash'
import createDebug from 'debug'
import {DESIGN_MODES} from '../Step2Container'

const Publish = ({disabled = false}) => {
    const {
        state: {
            productDetail,
            galleryImage,
            pickerVariants,
            runningImageCompress,
            currentBgImageBase64,
            currentBgImage,
            productCreatedType,
            designs,
            artworks,
            mappingProduct,
            designsCaptures,
            runningImageCombine,
            pickerAttributes,
            designMode,
            linkableSides,
            runningImageCombinedMode,
            runningImageCombinedModeCompleted,
        },
        dispatch
    } = useSelectedVariantContext()
    const {uploadBackground} = useUploadBackgroundPublish()
    const [createProductLoading, setCreateProductLoading] = useState(false)
    const [isClickNext, setIsClickNext] = useState(false)

    const combinedModeCondition = designMode === DESIGN_MODES.COMBINED ? runningImageCombinedModeCompleted !== runningImageCombinedMode : runningImageCombine;
    const isRegularTemplate = productCreatedType === 'regularHasTemplate' || productCreatedType === 'regularNoTemplate';
    const isDisableNext2 = combinedModeCondition && !isRegularTemplate;

    const {fetchCapturedSides} = usePreviewArtworks()

    const {fetchDesigns, fetchDesignsNoCapture, pending} = usePreviewArtworks()
    const navigate = useNavigate()

    const handleCreateProduct = async (data) => {
        try {
            await createProductCombine(data)
        } catch (err) {
            throw err
        }
    }

    const _generateArtworkPayload = async (designs, keyBackground, latestDesignsCaptures) => {
        const storeId = getCurrentStore()
        const base_url = getDefaultBaseURL()
        const _designCaptures = latestDesignsCaptures || designsCaptures
        const debug = createDebug("pf126:PLAT2-473");
        debug('designCapture 3', _designCaptures, latestDesignsCaptures, designsCaptures, designMode)
        return await Bluebird.all(
            designs.map(async ({mockup, listSku, design, level}, index) => {
                const {meta, side_infos} = mockup
                const artwork_fusion_size = Object.values(side_infos)[0].fusion_size.artwork_fusion_size
                const childs = linkableSides.length > 0 && !!linkableSides[index]?.linkableSides?.parent ? linkableSides[index]?.linkableSides?.childs : []
                const isSaveBack = childs.length > 0 ? childs.filter(item => item.onLinkable).length > 0 : false
                const skipCustomSides = childs.filter(item => item.onLinkable).map(item => item.side).filter(Boolean)
                if (isBackofficeEnv()) {
                    return {
                        variant_skus: listSku,
                        mockup_infos: meta.mockup_infos.map((item) => ({
                            name: item.name,
                            side: item.side,
                            background: keyBackground || undefined,
                        })),
                        base_url,
                        site_id: storeId,
                        resize_config: {
                            width: artwork_fusion_size.width,
                            height: artwork_fusion_size.height,
                        },
                        link: designMode === DESIGN_MODES.COMBINED ? _designCaptures[index]?.images['all-in-one'] : _designCaptures[index].mergeUrl,
                        side: isSaveBack ? 'back' : 'front',
                        skip_custom_sides: skipCustomSides,
                        level,
                        keyBackground,
                    }
                }

                return {
                    variant_skus: listSku,
                    mockup_infos: meta.mockup_infos.map((item) => ({
                        name: item.name,
                        side: item.side,
                        background: keyBackground || undefined,
                    })),
                    resize_config: {
                        width: artwork_fusion_size.width,
                        height: artwork_fusion_size.height,
                    },
                    link: designMode === DESIGN_MODES.COMBINED ? _designCaptures[index]?.images['all-in-one'] : _designCaptures[index].mergeUrl,
                    side: isSaveBack ? 'back' : 'front',
                    skip_custom_sides: skipCustomSides,
                    level,
                    keyBackground,
                }
            }),
        )
    }

    const _generateArtworkPayloadNoTemplate = async (_designs, presignedUrls) => {

        const storeId = getCurrentStore()
        const base_url = getDefaultBaseURL()
        return await Bluebird.all(
            _designs.map(async (design, index) => {
                const presignedUrl = presignedUrls[index]
                const {side} = designs[index]
                await uploadTempArtwork(presignedUrl, design.design)
                let artworks = []
                Object.keys(side).forEach((key) => {
                    const layers = side[key]?.layers || []
                    const url = layers.length > 0 ? layers[0]?.linkS3 || layers[0]?.src : ''
                    if (url) {
                        artworks.push({
                            side: key,
                            url
                        })
                    }
                })
                return {
                    product_id: '',
                    site_id: storeId,
                    base_url,
                    variant_skus: design.listSku,
                    artworks,
                    level: design.level
                }
            }),
        )
    }

    const _generateArtworkPayloadHasTemplate = async (_designs, presignedUrls) => {
        return await Bluebird.all(
            _designs.map(async ({mockup, listSku, design, level}, index) => {
                const previewV2 = mockup.preview_v2 || {}
                const key = Object.keys(previewV2).length > 0 ? Object.keys(previewV2)[0] : ''

                const presignedUrl = presignedUrls[index]
                await uploadTempArtwork(presignedUrl, design)

                return {
                    variant_skus: listSku,
                    mockup_infos: undefined,
                    artworks: [{
                        side: key,
                        url: presignedUrl ? presignedUrl?.split('?')[0] : ''
                    }],
                    level
                }
            }),
        )
    }

    const _generateArtworkPayloadCombine = async (designs, keyBackground, latestDesignsCaptures) => {
        const _newDesignCapture = latestDesignsCaptures || designsCaptures
        return await Bluebird.all(
            designs.map(async ({mockup, listSku, design, level}, index) => {
                const {meta} = mockup
                const previewV2 = mockup.preview_v2 || {}
                const key = Object.keys(previewV2).length > 0 ? Object.keys(previewV2)[0] : ''

                return {
                    variant_skus: listSku,
                    mockup_infos: productCreatedType === 'regularHasTemplate' ? undefined : meta.mockup_infos.map((item) => ({
                            name: item.name,
                            side: item.side,
                            background: keyBackground || undefined,
                        }),
                    ),
                    artworks: [{
                        side: key,
                        url: designMode === DESIGN_MODES.COMBINED ? _newDesignCapture[index]?.images['all-in-one'] : _newDesignCapture[index].mergeUrl
                    }],
                    level
                }
            }),
        )
    }

    const _generateArtworkPayloadType2DTemplate = async (designs, keyBackground, latestDesignsCaptures) => {
        const _newDesignCapture = latestDesignsCaptures || designsCaptures
        return await Bluebird.all(
            designs.map(async ({mockup, listSku, design, level, areas}, index) => {
                const itemDesign = _newDesignCapture[index]
                const {images: imagesSide} = itemDesign

                let _artworks = []
                await Bluebird.all(
                    Object.keys(imagesSide).map(async (key) => {
                        _artworks.push({
                            side: key,
                            url: imagesSide[key]
                        })
                    })
                )

                const {meta, preview_type, preview_v2} = mockup

                return {
                    variant_skus: listSku,
                    mockup_infos: meta.mockup_infos.map((item) => ({
                            name: item.name,
                            side: item.side,
                            background: keyBackground || undefined,
                        }),
                    ),
                    preview_v2,
                    preview_type,
                    artworks: _artworks,
                    level
                }
            }),
        )
    }

    const _handleClickSaveArtwork = async () => {
        setCreateProductLoading(true)
        const fetchedDesigns = mergeAttributesByDesignEdited(pickerAttributes, designs)
        const updatedCaptures = await fetchCapturedSides(fetchedDesigns, true)  // ← Nhận kết quả
        await _onClickPublish(updatedCaptures)
    }

    const initClickPublish = () => {
        const debug = createDebug("pf126:PLAT2-473");
        debug('designCapture 1', designsCaptures)
        if (isDisableNext2) {
            setCreateProductLoading(true)
            setIsClickNext(true)
        } else {
            mappingProduct ? _handleClickSaveArtwork() : _handleClickPublish()
        }
    }

    const _handleClickPublish = async () => {
        const debug = createDebug("pf126:PLAT2-473");
        debug('designsCaptures 2', designsCaptures)
        if (getLocalData('status_capture_background', '') === 'catured_error') {
            const fetchedDesigns = mergeAttributesByDesignEdited(pickerAttributes, designs)
            await fetchCapturedSides(fetchedDesigns, true)
        } else if (getLocalData('status_capture_background', '') === 'combined_error') {
            if (designMode === DESIGN_MODES.COMBINED) {
                return await _onClickPublish(designsCaptures)
            }
            await handleMergeDesignCaptures(designsCaptures, dispatch)
        }
        await _onClickPublish(designsCaptures)
    }

    const _onClickPublish = async (latestDesignsCaptures = null) => {
        try {
            setCreateProductLoading(true)

            let payload = []

            const debug = createDebug("pf126:PLC-12476");
            debug('productCreatedType', productCreatedType)

            if (productCreatedType === 'regularNoTemplate' || productCreatedType === 'regularHasTemplate') {
                const _designs = await fetchDesigns()
                const {data} = await getLinksUploadArtwork({limit: _designs.length})
                const presignedUrls = data || []
                if (presignedUrls.length !== _designs.length) throw new Error('Failed to get presigned url')

                payload = productCreatedType === 'regularNoTemplate' ?
                    await _generateArtworkPayloadNoTemplate(_designs, presignedUrls) :
                    await _generateArtworkPayloadHasTemplate(_designs, presignedUrls)
            } else {
                let keyBackground = ''
                if (currentBgImageBase64) {
                    const file = await base64ToFile(currentBgImageBase64, 'background-image.jpg', 'text/plain')
                    keyBackground = await uploadBackground(file)
                }
                const _designs = await fetchDesignsNoCapture()
                if (productCreatedType === 'combineLayout') {
                    payload = await _generateArtworkPayloadCombine(_designs, keyBackground, latestDesignsCaptures)
                } else if (productCreatedType === 'type2D') {
                    payload = await _generateArtworkPayloadType2DTemplate(_designs, keyBackground, latestDesignsCaptures)
                } else {
                    payload = await _generateArtworkPayload(_designs, keyBackground, latestDesignsCaptures)
                }
            }

            if (mappingProduct) {
                const variantPayload = payload.find((i) => i.level === 'variant') || payload[0] || {}

                const artworks = {}
                let byLink = false
                if (isArray(variantPayload.artworks)) {
                    variantPayload.artworks.forEach((artwork) => {
                        artworks[artwork.side] = artwork
                    })
                    byLink = true
                } else {
                    const childs = linkableSides.length > 0 && !!linkableSides[0]?.linkableSides?.parent ? linkableSides[0]?.linkableSides?.childs : []
                    const isSaveBack = childs.length > 0 ? childs.filter(item => item.onLinkable).length > 0 : false
                    if (isSaveBack) {
                        artworks.back = {
                            url: variantPayload?.link
                        }
                    } else {
                        artworks.front = {
                            url: variantPayload?.link
                        }
                    }
                    byLink = true
                }
                setLocalData('status_capture_background', '')
                const {productId: mappingProductId, variantId, sku } = mappingProduct || {}
                await createMappingAndSaveArtwork(mappingProductId, artworks, variantId, sku, byLink)
                navigate(`/mapping-variants/${mappingProductId}?variantId=${variantId}`)
                return
            }

            if (isBackofficeEnv()) {
                await handleCreateProduct({
                    product: productDetail,
                    variants: pickerVariants,
                    personalizedArtworkPayload: payload,
                    galleryImage,
                    currentBgImage,
                    productCreatedType,
                    designs: designs,
                    artworks
                })
                await Bluebird.delay(1000)
            } else {
                const {attributes, collections} = productDetail
                const filteredAttributes = attributes.map((attribute) => {
                    const filteredValues = attribute.values.filter((value) =>
                        pickerVariants.some((variant) =>
                            variant.attributes.some(
                                (variantAttribute) =>
                                    variantAttribute.name === attribute.name &&
                                    variantAttribute.value_code === value.code,
                            ),
                        ),
                    )

                    return {...attribute, values: filteredValues}
                })
                const tempMockupPayload = {
                    artworks: payload,
                    product: {
                        ...productDetail,
                        collections: Array.isArray(collections)
                            ? collections.map((collection) => collection.value)
                            : [],
                        productLine: {
                            variants: pickerVariants,
                            attributes: filteredAttributes,
                        },
                    },
                    gallery_urls: !!galleryImage ? galleryImage.map((img) =>
                        img.replace(
                            'regular.jpg',
                            `background:${currentBgImage?.file ? encodeURIComponent(encodeURIComponent(payload[0].keyBackground)) : 'default'}/regular.jpg`,
                        ),
                    ) : undefined,
                }
                delete tempMockupPayload.mockups
                const designLibraryData = getLocalData('designLibrary') || []

                const designLibrary =
                    designLibraryData.length > 0
                        ? designLibraryData
                        : payload.map((item) => ({
                              name: 'temp',
                              src: item.link,
                          }))

                const tempData = designLibrary.map((item) => {
                    return {
                        name: item.name,
                        link: item.src,
                    }
                })

                const {
                    success: successImage,
                    data: dataImage,
                    message: messageImage,
                } = await saveTempImagesDesign(tempData)
                if (!successImage) throw new Error(messageImage)
                    
                const {success, data, message} = await saveTempMockupDesign(tempMockupPayload)
                if (!success) throw new Error(message)
                setLocalData('status_capture_background', '')
                const redirect = `${
                    process.env.REACT_APP_BASE_URL || 'https://seller-staging.merchize.com'
                }/mockup-design?id=${data}&createMockup=true&idLibraries=${dataImage}`
                window.open(redirect, '_self')
            }
        } catch (error) {
            setLocalData('status_capture_background', '')
            setCreateProductLoading(false)
        }
    }

    useEffect(() => {
        if (isClickNext && !isDisableNext2) {
            setTimeout(() => {
                mappingProduct ? _handleClickSaveArtwork() : _handleClickPublish()
            }, 1000)
        }
    }, [isDisableNext2])

    return (
        <>
            <Button
                id={'header_next_btn'}
                color={'primary'}
                type={'button'}
                className={'Design btn btn-primary flex-center'}
                disabled={runningImageCompress || createProductLoading || pending || disabled}
                onClick={initClickPublish}
            >
                {createProductLoading ? (
                    <Spinner
                        size={'sm'}
                        style={{
                            '--bs-spinner-width': '1.5rem',
                            '--bs-spinner-height': '1.5rem',
                            // height: '100%'
                        }}
                    />
                ) : mappingProduct? (
                    <>
                        Save artwork
                    </>
                ) : (
                    <>
                        Next <ChevronRight className={'ms-1'} />
                    </>
                )}
            </Button>
            {/*<PFButton*/}
            {/*    type="button"*/}
            {/*    color="primary"*/}
            {/*    loading={loadingTemp}*/}
            {/*    onClick={}*/}
            {/*    className="Publish Design flex-center"*/}
            {/*    disabled={(disablePublish && display === 'pricing') || runningImageCompress || loadingTemp}*/}
            {/*    id={display === 'pricing' ? 'Publish' : 'Next'}*/}
            {/*    buttonText={*/}
            {/*        <>*/}
            {/*            {display === 'pricing' ? 'Publish' : 'Next'}*/}
            {/*            <ChevronRight width={7} height={10} className="Icon" />*/}
            {/*        </>*/}
            {/*    }*/}
            {/*/>*/}

            {/*{isBackofficeEnv() && isPublish && (*/}
            {/*    <ModalPublish*/}
            {/*        product={productDetail}*/}
            {/*        variants={pickerVariants}*/}
            {/*        galleryImage={galleryImage}*/}
            {/*        personalizedArtworkPayload={personalizedArtworkPayloads}*/}
            {/*        isOpen={isPublish}*/}
            {/*        onClose={() => setShowModalPublish(false)}*/}
            {/*    />*/}
            {/*)}*/}
        </>
    )
}

export default Publish
